<template>
  <BootstrapModal class="EditWebsiteMenu"
    v-on="$listeners"

    @save="saveProductGroup"
  >
    <FormInput
      class="form-element"
      v-model="$v.name.$model"

      id="color"
      label="Color"

      :vuelidate="$v"
      fieldName="name"
    />

    <template #title>
      {{ color ? "Edit Color" : "Add Color" }}
    </template>
  </BootstrapModal>
</template>

<script>

import BootstrapModal from "../BootstrapModal.vue"

import FormInput from "src/components/Inputs/FormInput.vue"

import { required } from "vuelidate/lib/validators"

export default {
  props: ["color", "callback"],
  components: {
    BootstrapModal,
    FormInput,
  },
  validations: {
    name: {
      required,
    },
  },
  data() {
    return {
      name: "",
    }
  },
  created() {
    if (this.color) {
      this.$v.name.$model = this.color.name
    }
  },
  methods: {
    saveProductGroup() {
      this.$v.$touch()
      if (this.$v.$error) return;

      const payload = {
        name: this.$v.name.$model,
      }

      this.$handlePromise(async () => {
        if (this.color) {
          await this.axios.put(`/api/colors/${this.color.uid}`, payload)
        } else {
          await this.axios.post(`/api/colors`, payload)
        }
        this.$store.dispatch('clearCacheSearch', "colors")

        this.$success("Color succesvol opgeslagen!")
        this.callback && this.callback()
        this.$emit("close")
      })
    },
  },
}

</script>

<style scoped>

.EditWebsiteMenu {
  flex-basis: 500px;
}

</style>
